module.exports = __webpack_public_path__ + "img/hotelricordu.0403d51b.png";